import { CARTOPOUSSE_BASE_URL } from '../utils/ApiUrls';

class AdminStatsService {

  // Get all dashboard statistics (4 cards data)
  async getDashboardStats(accessToken) {
    try {
      const response = await fetch(`${CARTOPOUSSE_BASE_URL}/admin/dashboard-stats/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.error || data.detail || 'Failed to fetch dashboard statistics',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Get 6-month activity trends for charts
  async getActivityTrends(accessToken) {
    try {
      const response = await fetch(`${CARTOPOUSSE_BASE_URL}/admin/activity-trends/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.error || data.detail || 'Failed to fetch activity trends',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Get risk priority distribution for donut chart
  async getRiskDistribution(accessToken) {
    try {
      const response = await fetch(`${CARTOPOUSSE_BASE_URL}/admin/risk-distribution/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.error || data.detail || 'Failed to fetch risk distribution',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Get recent history records for admin dashboard
  async getRecentHistories(accessToken) {
    try {
      const response = await fetch(`${CARTOPOUSSE_BASE_URL}/admin/recent-histories/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.error || data.detail || 'Failed to fetch recent histories',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }


  // Get recent history records for admin dashboard
async getRecentHistories(accessToken) {
  try {
    const response = await fetch(`${CARTOPOUSSE_BASE_URL}/admin/recent-histories/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        status: response.status,
        error: data.error || data.detail || 'Failed to fetch recent histories',
        errorData: data,
      };
    }

    return {
      success: true,
      status: response.status,
      data,
    };
  } catch (error) {
    return {
      success: false,
      status: 0,
      error: error.message || 'Network error occurred',
      errorData: null,
    };
  }
}


}

// Export singleton instance
const adminStatsService = new AdminStatsService();
export default adminStatsService;